var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "mask", on: { click: _vm.close } }, [
    _c(
      "div",
      {
        staticClass: "payBox",
        on: {
          click: function($event) {
            $event.stopPropagation()
          }
        }
      },
      [
        _c("div", { staticClass: "topBox" }, [
          _c("div", { staticClass: "clickBox", on: { click: _vm.close } }, [
            _c("img", { attrs: { src: require("assets/close.png"), alt: "" } })
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "amount" }, [
          _c("span", [_vm._v("￥")]),
          _vm._v(_vm._s(_vm.price))
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "infoTitle" }, [_vm._v("选择支付方式")]),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "layer",
            on: {
              click: function($event) {
                _vm.selectPayType(0)
              }
            }
          },
          [
            _vm._m(0),
            _vm._v(" "),
            _c("div", {
              staticClass: "choose",
              class: { active: _vm.payType === 0 }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "layer",
            on: {
              click: function($event) {
                _vm.selectPayType(1)
              }
            }
          },
          [
            _vm._m(1),
            _vm._v(" "),
            _c("div", {
              staticClass: "choose",
              class: { active: _vm.payType === 1 }
            })
          ]
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass: "btn",
            on: {
              click: function($event) {
                _vm.pay()
              }
            }
          },
          [_vm._v("确认付款")]
        )
      ]
    )
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconBox" }, [
      _c("img", { attrs: { src: require("assets/aplipay.png"), alt: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v("支付宝")])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "iconBox" }, [
      _c("img", { attrs: { src: require("assets/wxpay.png"), alt: "" } }),
      _vm._v(" "),
      _c("span", [_vm._v("微信")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-1b96a9ce", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-1b96a9ce","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/payAssembly.vue
// module id = null
// module chunks = 